import classNames from 'classnames';

import { DialogContent } from '../../../../components/Dialog/DialogContent';
import { DialogHeader } from '../../../../components/Dialog/DialogHeader';
import { Loader } from '../../../../components/Loader/Loader';

import styles from './PlaceholderView.module.scss';

export function PlaceholderView({ isCashRedeem }: { isCashRedeem?: boolean }) {
  return (
    <>
      {!isCashRedeem ? <DialogHeader title="Processing..." /> : <></>}
      <DialogContent>
        <Loader
          customClassName={classNames({
            [styles.placeholderContainerWithSelectedWin]: isCashRedeem,
          })}
        />
      </DialogContent>
    </>
  );
}
